import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center place-content-center h-full w-full z-5" }
const _hoisted_2 = { class: "dialog p-4 text-center" }
const _hoisted_3 = { class: "relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 min-w-[200px]" }
const _hoisted_4 = { class: "sm:flex sm:items-start" }
const _hoisted_5 = { class: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-gray-100 sm:mx-0 sm:h-10 sm:w-10" }
const _hoisted_6 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" }
const _hoisted_7 = { class: "text-lg leading-6 font-medium text-gray-900" }
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = { class: "text-sm text-gray-500" }
const _hoisted_10 = { class: "mt-5 sm:mt-4 sm:ml-10 sm:pl-4 flex flex-col space-y-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionMarkCircleIcon = _resolveComponent("QuestionMarkCircleIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FocusTrap = _resolveComponent("FocusTrap")!
  const _directive_motion_pop = _resolveDirective("motion-pop")!

  return (_openBlock(), _createBlock(_component_FocusTrap, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "absolute w-full bg-white bg-opacity-60 transition-opacity z-5",
        style: _normalizeStyle(_ctx.containerStyle)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_QuestionMarkCircleIcon, {
                    class: _normalizeClass([_ctx.iconClass, "h-6 w-6 fill-current"]),
                    "aria-hidden": "true"
                  }, null, 8, ["class"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.title), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.text), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Button, {
                  kind: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeDialog()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.confirmLabel), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  kind: "secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeDialog(false)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.cancelLabel), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])), [
            [_directive_motion_pop]
          ])
        ])
      ], 4)
    ]),
    _: 1
  }))
}